import { useState, useEffect } from 'react';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var getNavigatorConnection = function getNavigatorConnection() {
  if ((typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) !== 'object') {
    return undefined;
  }

  return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
};

var getNetworkInformation = function getNetworkInformation() {
  var connectionObject = getNavigatorConnection();

  if (!connectionObject) {
    return {
      data: {
        networkInformationSupported: false
      }
    };
  } // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation


  var downlink = connectionObject.downlink,
      downlinkMax = connectionObject.downlinkMax,
      effectiveType = connectionObject.effectiveType,
      type = connectionObject.type,
      rtt = connectionObject.rtt,
      saveData = connectionObject.saveData;
  return {
    data: {
      networkInformationSupported: true,
      downlink: downlink,
      downlinkMax: downlinkMax,
      effectiveType: effectiveType,
      type: type,
      rtt: rtt,
      saveData: saveData
    },
    connectionObject: connectionObject
  };
};

var handleOnline = function handleOnline(setState) {
  return function () {
    setState(function (state) {
      return _extends({}, state, {
        online: true,
        since: new Date().getTime()
      });
    });
  };
};

var handleOffline = function handleOffline(setState) {
  return function () {
    setState(function (state) {
      return _extends({}, state, {
        online: false,
        since: new Date().getTime()
      });
    });
  };
};

var onNetworkInformationChange = function onNetworkInformationChange(setState) {
  return function () {
    setState(function (state) {
      return _extends({}, state, getNetworkInformation());
    });
  };
};

var useConnection = function useConnection() {
  var _useState = useState(),
      _useState2 = slicedToArray(_useState, 2),
      connection = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    var network = getNetworkInformation();
    var handleOnline$$1 = handleOnline(setState);
    var handleOffline$$1 = handleOffline(setState);
    var onNetworkInformationChange$$1 = onNetworkInformationChange(setState);
    window.addEventListener('online', handleOnline$$1);
    window.addEventListener('offline', handleOffline$$1);

    if (network.connectionObject && network.data.networkInformationSupported) {
      network.connectionObject.addEventListener('change', onNetworkInformationChange$$1);
    }

    setState(function (state) {
      return _extends({}, state, {
        online: navigator.onLine,
        since: new Date().getTime()
      }, getNetworkInformation());
    });
    return function () {
      window.removeEventListener('online', handleOnline$$1);
      window.removeEventListener('offline', handleOffline$$1);

      if (network.connectionObject && network.data.networkInformationSupported) {
        network.connectionObject.removeEventListener('change', onNetworkInformationChange$$1);
      }
    };
  }, []);
  return connection;
};

export default useConnection;